




import VueOptions from '@utils/VueOptions'
import SupplierListItem from '@superComponents/Supplier/SupplierListItem'
import UiList from '@superUI/InfiniteList'

settings = 
  name: 'SupplierList'
  components: { SupplierListItem, UiList }

export default VueOptions.vue settings
